module.exports = __webpack_public_path__ + "img/mo.0dc09f49.svg";